import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Event, EventParticipationAnswer } from '../../types/event';

export interface EventState {
  eventMap: Record<number, Event[]>;
}
const initialState: EventState = {
  eventMap: {},
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    createEvent: (state, action: PayloadAction<{ communityId: number; event: Event }>): void => {
      const { communityId, event } = action.payload;
      if (!state.eventMap[communityId]) {
        state.eventMap[communityId] = [];
      }
      state.eventMap[communityId].push(event);
    },

    setEvents(state, action: PayloadAction<{ communityId: number; events: Event[] }>): void {
      const { communityId, events } = action.payload;
      if (!state.eventMap[communityId]) {
        state.eventMap[communityId] = [];
      }
      state.eventMap[communityId] = events;
    },

    deleteEvent(state, action: PayloadAction<{ communityId: number; eventId: number }>): void {
      const { communityId, eventId } = action.payload;
      state.eventMap[communityId] = state.eventMap[communityId].filter(
        (event) => event.id !== eventId,
      );
    },

    updateEvent(state, action: PayloadAction<{ communityId: number; event: Event }>): void {
      const { communityId, event } = action.payload;
      state.eventMap[communityId] = state.eventMap[communityId].map((e) =>
        e.id === event.id ? event : e,
      );
      if (!state.eventMap[communityId].find((e) => e.id === event.id))
        state.eventMap[communityId].push(event);
    },

    setAttendance(
      state,
      action: PayloadAction<{
        communityId: number;
        participantId: number;
        answer: EventParticipationAnswer;
      }>,
    ) {
      const { communityId, participantId, answer } = action.payload;
      if (!state.eventMap[communityId]) state.eventMap[communityId] = [];
      state.eventMap[communityId] = state.eventMap[communityId].map((e) => ({
        ...e,
        participants: e.participants.map((p) => (p.id === participantId ? { ...p, answer } : p)),
      }));
    },
  },
});

export const { createEvent, setEvents, deleteEvent, updateEvent, setAttendance } =
  eventSlice.actions;
const eventReducer = eventSlice.reducer;
export default eventReducer;
